// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flat-variant.set-height[data-v-4ba1691e]{height:630px;width:288px}@media only screen and (min-width:960px)and (max-width:1263.98px){.flat-variant.set-height[data-v-4ba1691e]{height:420px;width:192px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
